import React, { useEffect, useState } from 'react';
import { Badge, Modal, ModalBody, ModalHeader } from 'reactstrap';
import AuthTenantLoader from '../../../pages/loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../pages/error/AuthTenantPageError';
import { Block, Button, DataTableHead, DataTableItem, DataTableRow, PaginationComponent } from '../../Component';
import CardTabs from '../../../pages/components/cards/CardTabs';
import { useDispatch, useSelector } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { RETRIEVE_TENANT_PRODUCT_STOCK_AGE_ANALYSIS_BREAKDOWN_API } from '../../../api/api_data';
import { fail_tenant_retrieve_product_stock_age_analysis_breakdown, loading_tenant_retrieve_product_stock_age_analysis_breakdown, reset_tenant_retrieve_product_stock_age_analysis_breakdown, success_tenant_retrieve_product_stock_age_analysis_breakdown } from '../../../reducers/auth_tenant/tenant_retrieve_product_stock_age_analysis_breakdown_Slice';
import { formatNumber, formatToSentenceCase, joinWithCommas, messageToast } from '../../../utils/Utils';
import { COULD_NOT_RETRIEVE_PRODUCT_STOCK_AGE_ANALYSIS_BREAKDOWN_ERROR_MSG, COULD_NOT_RETRIEVE_PRODUCT_STOCK_AGE_ANALYSIS_BREAKDOWN_SUCCESS_MSG } from '../../../utils/error_success_messages';
import * as app_consts from "../../../utils/app_consts";
import moment from 'moment';
import { download, generateCsv, mkConfig } from 'export-to-csv';

const ViewBrandStockAgeProductBreakDownModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [sent_data, setSentData] = useState(data);
  const [page_data, setPageData] = useState([]);
  const [activeCardTab, setActiveCardTab] = useState("Main Details");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [sm, updateSm] = useState(false);
  const [openCycle, setOpenCycle] = useState(null);

  const toggleCycle = (key) => {
    setOpenCycle(openCycle === key ? null : key);
  };

  useEffect(() => {
    setError("");
    setSentData(data);
    setOpen(isOpen);


    if (isOpen && data)
    {
      retrieve_data(data);
    }
  }, [isOpen, data]);

  const retrieve_data = (id) => {
    setError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_tenant_retrieve_product_stock_age_analysis_breakdown, success_tenant_retrieve_product_stock_age_analysis_breakdown, fail_tenant_retrieve_product_stock_age_analysis_breakdown, COULD_NOT_RETRIEVE_PRODUCT_STOCK_AGE_ANALYSIS_BREAKDOWN_ERROR_MSG, COULD_NOT_RETRIEVE_PRODUCT_STOCK_AGE_ANALYSIS_BREAKDOWN_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCT_STOCK_AGE_ANALYSIS_BREAKDOWN_API}/${id}`));
  };

  const tenant_retrieve_product_stock_age_analysis_breakdown_listner = useSelector((state) => state.tenant_retrieve_product_stock_age_analysis_breakdown.tenant_retrieve_product_stock_age_analysis_breakdown);

  useEffect(() => {
    if (tenant_retrieve_product_stock_age_analysis_breakdown_listner.status !== app_consts.IDLE)
    {
      if (tenant_retrieve_product_stock_age_analysis_breakdown_listner.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (tenant_retrieve_product_stock_age_analysis_breakdown_listner.status === app_consts.FAIL)
        {
          setError(tenant_retrieve_product_stock_age_analysis_breakdown_listner.message);
          messageToast(tenant_retrieve_product_stock_age_analysis_breakdown_listner.message, app_consts.FAIL);
        } else if (tenant_retrieve_product_stock_age_analysis_breakdown_listner.status === app_consts.SUCCESS)
        {
          setPageData(tenant_retrieve_product_stock_age_analysis_breakdown_listner.data);
        }
        dispatch(reset_tenant_retrieve_product_stock_age_analysis_breakdown());
      }
    }
  }, [tenant_retrieve_product_stock_age_analysis_breakdown_listner]);

  const tabs = [
    {
      tabName: "Main Details"
    },
    {
      tabName: "Breakdown"
    }
  ];

  // Pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = page_data?.product_breakdown?.slice(indexOfFirstItem, indexOfLastItem);

  // Save page to localStorage
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const export_cycle_to_csv = async (e, cycle) => {
    e.preventDefault();

    const csv_data = [
      // Product information
      {
        col1: "Product ID",
        col2: "Product Name",
        col3: "Product Category",
        col4: "Cycle Balance",
        col5: "",
      },
      {
        col1: page_data?.product?.id || "--",
        col2: page_data?.product?.name || "--",
        col3: page_data?.product?.category || "--",
        col4: (cycle?.total_in || 0) - (cycle?.total_out || 0),
        col5: "",
      },

      // Blank row
      {
        col1: "",
        col2: "",
        col3: "",
        col4: "",
        col5: "",
      },

      // Summary section header
      {
        col1: "Cycle Start",
        col2: "Cycle End",
        col3: "Average Age Days",
        col4: "Total In",
        col5: "Total Out",
      },

      // Summary section values
      {
        col1: cycle?.cycle_start
          ? moment(cycle.cycle_start).format("YYYY-MM-DD HH:mm:ss")
          : "--",
        col2: cycle?.cycle_end
          ? moment(cycle.cycle_end).format("YYYY-MM-DD HH:mm:ss")
          : "ONGOING",
        col3: formatNumber(cycle?.average_age_days || 0),
        col4: formatNumber(cycle?.total_in || 0),
        col5: formatNumber(cycle?.total_out || 0),
      },

      // Blank rows
      {
        col1: "",
        col2: "",
        col3: "",
        col4: "",
        col5: "",
      },
      {
        col1: "",
        col2: "",
        col3: "",
        col4: "",
        col5: "",
      },

      // Detail section header
      {
        col1: "Movement Date",
        col2: "Quantity",
        col3: "Stock Age Days",
        col4: "",
        col5: "",
      },
    ];

    // Detail rows
    cycle?.outs?.forEach((out) => {
      csv_data.push({
        col1: out?.movement_datetime
          ? moment(out.movement_datetime).format("YYYY-MM-DD HH:mm:ss")
          : "--",
        col2: formatNumber(out?.quantity || 0),
        col3:
          out?.stock_age_days != null
            ? Number(out.stock_age_days).toFixed(2)
            : "--",
        col4: "",
        col5: "",
      });
    });

    const options = mkConfig({
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showTitle: false,
      showLabels: false,
      useBom: true,
      useKeysAsHeaders: false,
      filename: `Stock_Age_Product_Cycle_${cycle?.cycle_start
        ? moment(cycle.cycle_start).format("YYYYMMDD_HHmmss")
        : moment().format("YYYYMMDD_HHmmss")
        }`,
      columnHeaders: [
        { key: "col1", displayLabel: "" },
        { key: "col2", displayLabel: "" },
        { key: "col3", displayLabel: "" },
        { key: "col4", displayLabel: "" },
        { key: "col5", displayLabel: "" },
      ],
    });

    const csv = generateCsv(options)(csv_data);
    download(options)(csv);
  };

  return (
    <>
      < Modal isOpen={open} className="modal-dialog-centered" size={"xl"}  >
        <ModalHeader toggle={!(loading) ? () => {
          successFunction();
          closeModal();
        } : undefined}>Brand Stock Age Product Analysis Details</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <AuthTenantLoader tenant_info={tenant_info} loading_message="Retrieving Breakdown Details..." />
              </>
              :
              <>
                {
                  error ?
                    <>
                      <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                    </>
                    :
                    <>
                      <Block>
                        <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                      </Block>
                      <div className="card-inner bg-white">
                        {
                          activeCardTab === "Main Details" && (
                            <>
                              <div className="profile-ud-list">
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Product Name</span>
                                    <span className="profile-ud-value">{page_data?.product?.name || "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Brand</span>
                                    <span className="profile-ud-value">{page_data?.product?.category || "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Balance</span>
                                    <span className="profile-ud-value">{page_data?.balance || "0"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Product Type</span>
                                    <span className="profile-ud-value">{page_data?.product?.product_type || "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Packet Sizes</span>
                                    <span className="profile-ud-value">{page_data?.product?.packet_sizes ? joinWithCommas(page_data?.product?.packet_sizes) : "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Colors</span>
                                    <span className="profile-ud-value">{page_data?.product?.colors ? joinWithCommas(page_data?.product?.colors) : "--"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Returnable</span>
                                    <span className="profile-ud-value">{page_data?.product?.returnable ? "YES" : "NO"}</span>
                                  </div>
                                </div>
                                <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                    <span className="profile-ud-label">Status</span>
                                    <span className="profile-ud-value">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            page_data?.product?.status === app_consts.ACTIVE
                                              ? "success"
                                              : "warning"
                                          }
                                          className="badge-dot"
                                        >
                                          {page_data?.product?.status ? formatToSentenceCase(page_data?.product?.status)?.toUpperCase() : "--"}
                                        </Badge>
                                      </span></span>
                                  </div>
                                </div>
                              </div>
                            </>
                          )
                        }
                        {
                          activeCardTab === "Breakdown" && (
                            <>
                              <Block>
                                <div className="nk-tb-list is-separate is-medium mb-3">
                                  <DataTableHead className="nk-tb-item">
                                    <DataTableRow><span className="sub-text">Cycle Start</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Cycle End</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Average Days</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Total In</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Total Out</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">View</span></DataTableRow>
                                    <DataTableRow><span className="sub-text">Export</span></DataTableRow>
                                  </DataTableHead>
                                  {currentItems.length > 0 &&
                                    currentItems.map((item) => {
                                      const isOpen = openCycle === item.cycle_start;

                                      return (
                                        <React.Fragment key={item.cycle_start}>

                                          {/* MAIN ROW */}
                                          <DataTableItem>
                                            <DataTableRow>
                                              <span className="tb-lead">
                                                {item?.cycle_start
                                                  ? moment(item.cycle_start).format("YYYY-MM-DD HH:mm:ss")
                                                  : "--"}
                                              </span>
                                            </DataTableRow>

                                            <DataTableRow>
                                              <span className="tb-lead">
                                                {item?.cycle_end
                                                  ? moment(item.cycle_end).format("YYYY-MM-DD HH:mm:ss")
                                                  : "--"}
                                              </span>
                                            </DataTableRow>

                                            <DataTableRow>
                                              <span className="tb-lead">
                                                {formatNumber(item?.average_age_days) || "--"}
                                              </span>
                                            </DataTableRow>

                                            <DataTableRow>
                                              <span className="tb-lead">
                                                {formatNumber(item?.total_in || 0)}
                                              </span>
                                            </DataTableRow>

                                            <DataTableRow>
                                              <span className="tb-lead">
                                                {formatNumber(item?.total_out || 0)}
                                              </span>
                                            </DataTableRow>


                                            {/* ACTION BUTTON */}

                                            <DataTableRow>
                                              <Button
                                                size="sm"
                                                color="primary"
                                                className="btn-dim"
                                                onClick={() => toggleCycle(item.cycle_start)}
                                              >
                                                {isOpen ? "Hide" : "View"}
                                              </Button>
                                            </DataTableRow>

                                            <DataTableRow>
                                              <Button
                                                size="sm"
                                                color="success"
                                                onClick={(e) => export_cycle_to_csv(e, item)}
                                              >
                                                Export
                                              </Button>
                                            </DataTableRow>
                                          </DataTableItem>

                                          {/* EXPANDED ROW (FULL WIDTH) */}
                                          {isOpen && (
                                            <>
                                              {/* Spacer rows */}
                                              <div style={{ height: "20px" }} />
                                              <div style={{ height: "20px" }} />

                                              <DataTableHead className="nk-tb-item">
                                                <DataTableRow>
                                                  <span className="sub-text">Date</span>
                                                </DataTableRow>
                                                <DataTableRow>
                                                  <span className="sub-text">Qty</span>
                                                </DataTableRow>
                                                <DataTableRow>
                                                  <span className="sub-text">Age (Days)</span>
                                                </DataTableRow>
                                              </DataTableHead>

                                              {item.outs?.map((out, idx) => (
                                                <DataTableItem key={idx}>
                                                  <DataTableRow>
                                                    {moment(out.movement_datetime).format(
                                                      "YYYY-MM-DD HH:mm:ss"
                                                    )}
                                                  </DataTableRow>

                                                  <DataTableRow>
                                                    {formatNumber(out.quantity)}
                                                  </DataTableRow>

                                                  <DataTableRow>
                                                    {out.stock_age_days?.toFixed(2)}
                                                  </DataTableRow>
                                                </DataTableItem>
                                              ))}
                                            </>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                </div>
                                {currentItems.length > 0 && (
                                  <div className="mt-3">
                                    <PaginationComponent
                                      itemPerPage={itemPerPage}
                                      totalItems={page_data?.product_breakdown?.length}
                                      paginate={paginate}
                                      currentPage={currentPage}
                                    />
                                  </div>
                                )}
                              </Block>
                              {/* [
  %{
    outs: [
      %{
        movement_datetime: ~U[2025-04-25 08:25:26Z],
        quantity: 32.0,
        stock_age_days: 1.98
      },
      %{
        movement_datetime: ~U[2025-04-26 14:43:25Z],
        quantity: 1200.0,
        stock_age_days: 3.25
      },
      %{
        movement_datetime: ~U[2025-06-26 20:50:45Z],
        quantity: 36.0,
        stock_age_days: 64.5
      },
      %{
        movement_datetime: ~U[2025-07-01 11:07:54Z],
        quantity: 65.0,
        stock_age_days: 69.1
      },
      %{
        movement_datetime: ~U[2025-07-01 11:12:19Z],
        quantity: 4967.0,
        stock_age_days: 69.1
      },
      %{
        movement_datetime: ~U[2025-12-17 03:39:55Z],
        quantity: 3.0,
        stock_age_days: 237.79
      }
    ],
  }
] */}
                            </>
                          )
                        }
                      </div>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewBrandStockAgeProductBreakDownModal;